module.exports = __webpack_public_path__ + "img/goods11-5.89869c4f.jpg";